import React, { useEffect, useState } from 'react';
import { Box, DropButton, TextInput, Text } from 'grommet';
import { ObjectGroup } from 'grommet-icons';
import TagItem from '../tag-item';

const Suggestion = group => {
  return {
    value: group.field,
    label: (
      <Box direction='row' pad='small' gap='small' justify='between'>
        <Text title={group.label} truncate>
          {group.label}
        </Text>
      </Box>
    )
  };
};

const GroupBuilder = ({
  availableGroups = [],
  selectedGroups = [],
  setGroups,
  disabled
}) => {
  const allOptions = [...availableGroups];
  const availableSuggestions = allOptions.filter(
    g => selectedGroups.indexOf(g.field) === -1
  );
  const [suggestions, setSuggestions] = useState(availableSuggestions);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSuggestions(
      allOptions
        .filter(
          g =>
            selectedGroups.indexOf(g.field) === -1 &&
            g.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
        )
        .map(Suggestion)
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroups, searchValue]);

  return (
    <Box direction='row' gap='small' align='center'>
      <DropButton
        disabled={selectedGroups.length === 0}
        icon={
          <Box margin={{ vertical: 'small' }}>
            <ObjectGroup color={selectedGroups.length > 0 && 'brand500'} />
          </Box>
        }
        plain
        dropAlign={{ top: 'bottom', left: 'left' }}
        dropContent={
          <Box pad='medium' background='white' gap='xsmall' flex>
            <Text>Active Groups</Text>
            {selectedGroups.map((g, i) => {
              return (
                <Box
                  key={g}
                  direction='row'
                  gap='xsmall'
                  flex={{ shrink: 0 }}
                  align='center'
                >
                  <Text style={{ marginRight: `${8 * i}px` }}>{i + 1}:</Text>
                  <TagItem
                    tag={allOptions.find(ag => ag.field === g)?.label}
                    onRemoveClick={() => {
                      const newGroups = [...selectedGroups];
                      newGroups.splice(i, 1);
                      setGroups(newGroups);
                    }}
                    maxWidth='200px'
                  />
                </Box>
              );
            })}
          </Box>
        }
      />

      <Box width='200px'>
        <TextInput
          disabled={disabled}
          title={
            disabled
              ? 'Choose a date range less than 10 days if you want to group data'
              : 'Group report by fields'
          }
          placeholder='Add Group'
          value={searchValue}
          onChange={e => {
            setSearchValue(e.target.value);
          }}
          suggestions={suggestions}
          onSelect={e => {
            setGroups([...selectedGroups, e.suggestion.value]);
          }}
        />
      </Box>
    </Box>
  );
};

GroupBuilder.displayName = 'GroupBuilder';

export default GroupBuilder;
